import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { RegiaoSelectComponent } from './regiao-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        RegiaoSelectComponent
    ],
    exports: [
        RegiaoSelectComponent
    ]
})
export class RegiaoSelectModule { }

